import { HackleInAppMessage } from "../../../public/model"
import BrowserPropertyProvider from "../../property/BrowserPropertyProvider"
import { WebAppInAppMessageView } from "./HackleWebAppInAppMessage"
import {
  CloseInAppMessageViewInvocation,
  CloseInAppMessageViewInvocationDto,
  HackleAppInvocationProcessor
} from "../invocator/HackleAppInvocationProcessor"

export class HackleWebAppInAppMessageView implements WebAppInAppMessageView {
  constructor(
    readonly id: string,
    readonly inAppMessage: HackleInAppMessage,
    private readonly invocationProcessor: HackleAppInvocationProcessor,
    private readonly browserPropertyProvider: BrowserPropertyProvider
  ) {}

  close(): void {
    const invocation: CloseInAppMessageViewInvocation = {
      command: "closeInAppMessageView",
      parameters: { viewId: this.id },
      browserProperties: this.browserPropertyProvider.getBrowserProperties()
    }
    this.invocationProcessor.process<CloseInAppMessageViewInvocationDto, void>(invocation)
  }
}
